import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import Home from "./home";

const HomePage = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <Home />
    </QueryClientProvider>
  );
};

export default HomePage;
